import * as actionTypes from './actionTypes'
import SarafanApiClient from '../../services/SarafanApiClient'

const AuthErrors = {
  loginFailed: 'Не удалось авторизоваться. Проверьте email или пароль.'
}

export const login = (email, password, successCallback, errorCallback) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LOGIN_REQUESTED
    })

    SarafanApiClient.login({ email, password })
      .then((response) => {
        if (response &&
          response.body &&
          response.body.is_successful &&
          response.body.data.user &&
          response.body.data.access_token)
        {
          dispatch({
            type: actionTypes.LOGIN_SUCCEED,
            user: response.body.data.user,
            access_token: response.body.data.access_token,
          })
          successCallback()
        } else {
          dispatch({
            type: actionTypes.LOGIN_FAIL
          })
          errorCallback(AuthErrors.loginFailed)
        }

      })
      .catch((error) => {
        dispatch({
          type: actionTypes.LOGIN_FAIL
        })
        errorCallback(AuthErrors.loginFailed)
      })
  }
}

export const logout = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LOGOUT
    })
  }
}

export const increment = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.INCREMENT_REQUESTED
    })

    dispatch({
      type: actionTypes.INCREMENT
    })
  }
}

export const incrementAsync = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.INCREMENT_REQUESTED
    })

    return setTimeout(() => {
      dispatch({
        type: actionTypes.INCREMENT
      })
    }, 3000)
  }
}

export const decrement = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.DECREMENT_REQUESTED
    })

    dispatch({
      type: actionTypes.DECREMENT
    })
  }
}

export const decrementAsync = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.DECREMENT_REQUESTED
    })

    return setTimeout(() => {
      dispatch({
        type: actionTypes.DECREMENT
      })
    }, 3000)
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js